import { formatBoth, parseInstantWithOffset } from "@compliance/domain";
import { Card, Grid, Group, Stack, Text, Title } from "@mantine/core";
import type { BatchDetail } from "../../api/types";
import { BatchStateBadge } from "../../components/BatchStateBadge";
import { UnitValue } from "../../components/UnitValue";

export function Overview({ batch }: { batch: BatchDetail }) {
  const start = formatBoth(parseInstantWithOffset(batch.period_start));
  const end = formatBoth(parseInstantWithOffset(batch.period_end));
  return (
    <Stack gap="md">
      <Title order={4}>Overview</Title>
      <Card withBorder shadow="xs">
        <Grid gutter="lg">
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Stack gap="xs">
              <KV label="Batch ID" value={batch.batch_id} mono />
              <KV label="Period" value={batch.period_label ?? batch.period_start.slice(0, 7)} />
              <KV label="State">
                <BatchStateBadge state={batch.state} />
              </KV>
            </Stack>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <Stack gap="xs">
              {batch.totals?.feedstock_lbs ? (
                <KV label="Feedstock (lbs)">
                  <UnitValue
                    value={batch.totals.feedstock_lbs.value}
                    basis="lbs"
                    decimalPlaces={2}
                    showBasis={false}
                  />
                </KV>
              ) : null}
              <KV label="Created" value={batch.created_at} mono />
              <KV label="Updated" value={batch.updated_at} mono />
            </Stack>
          </Grid.Col>
        </Grid>

        <Group mt="md" gap="lg" wrap="wrap">
          <Stack gap={2}>
            <Text size="xs" c="dimmed">
              Period start (PT)
            </Text>
            <Text size="xs" ff="monospace">
              {start.pt}
            </Text>
            <Text size="xs" c="dimmed" ff="monospace">
              UTC: {start.utc}
            </Text>
          </Stack>
          <Stack gap={2}>
            <Text size="xs" c="dimmed">
              Period end (PT)
            </Text>
            <Text size="xs" ff="monospace">
              {end.pt}
            </Text>
            <Text size="xs" c="dimmed" ff="monospace">
              UTC: {end.utc}
            </Text>
          </Stack>
        </Group>
      </Card>
    </Stack>
  );
}

function KV({
  label,
  value,
  mono,
  children,
}: {
  label: string;
  value?: string;
  mono?: boolean;
  children?: React.ReactNode;
}) {
  return (
    <Group gap="sm" wrap="nowrap">
      <Text size="sm" c="dimmed" w={140}>
        {label}
      </Text>
      {children ? (
        children
      ) : (
        <Text size="sm" ff={mono ? "monospace" : undefined}>
          {value}
        </Text>
      )}
    </Group>
  );
}
